import styles from './TableBody.module.scss';

type Props = {
  /**
   * The content to render within the component.
   * Typically a `TableRow` component.
   */
  children: React.ReactNode;
};

/**
 * The `tbody` tag; use to display data.
 */
export const TableBody = (props: Props) => {
  return (
    <tbody className={styles.tableBody} data-zds>
      {props.children}
    </tbody>
  );
};
